import Vue from 'vue'
import { MonthPickerInput } from 'vue-month-picker'

Vue.component('month-picker-input', MonthPickerInput)
